import { Icon, Link } from '@ztechapps/webui.util'
import React from 'react'
import { useAppContext } from '../../hooks/useAppContext'

export const ToggleSidebarButton = () => {
  const { toggleSidebar } = useAppContext()

  return (
    <Link onClick={toggleSidebar.toggle}>
      <Icon name="bars" className="toggle-sidebar-btn" />
    </Link>
  )
}
